import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import { ToastrService } from "ngx-toastr";
import { InstagramService } from "src/app/services/social/instagram.service";
import { FeedLoadingService } from "src/app/services/social/feed-loading.service";
import {Subject} from 'rxjs';
import {debounceTime, takeUntil} from 'rxjs/operators';

@Component({
  selector: "app-instagram-item",
  templateUrl: "./instagram-item.component.html",
  styleUrls: ["./instagram-item.component.css"],
})
export class InstagramItemComponent implements OnInit , OnDestroy{

  @Input() media: any = {};
  @Input() instagramName: '';
  @Input() itemType: any = {};
  showFullCaption = false;
  activeSlide = 0;
  loadingPostLink = false;
  loadingAction: "reply" | "view-reply" | "post" | null = null;
  private _isLoading = false;
  get isLoading(): boolean {
    return this._isLoading;
  }
  set isLoading(v: boolean) {
    this._isLoading = v;
  }
  get isAnyLoading(): boolean {
    return this.loadingPostLink || this.loadingAction !== null || this.feedLoadingService.isLoadingValue;
  }
  private clickSubject = new Subject<() => void>();
  private destroy$ = new Subject<void>();
  constructor(
    private instagramService: InstagramService,
    private toaster: ToastrService,
    private feedLoadingService: FeedLoadingService
  ) {
  }

  ngOnInit() {
    this.clickSubject.pipe(
      debounceTime(300),
      takeUntil(this.destroy$)
    ).subscribe(fn => fn());

    this.instagramService.postModalReady$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.resetLoadingState());
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this._isLoading = false;
    this.feedLoadingService.clearLoading();
  }

  private resetLoadingState() {
    this.isLoading = false;
    this.loadingPostLink = false;
    this.loadingAction = null;
    this.feedLoadingService.clearLoading();
  }
  nextSlide() {
    const max = this.media.children.data.length;
    if (this.activeSlide < max) { this.activeSlide++; }
  }

  prevSlide() {
    if (this.activeSlide > 0) { this.activeSlide--; }
  }
  onPostLinkClick(media: any) {
    if (this.isAnyLoading) return;
    this.loadingPostLink = true;
    this.feedLoadingService.setLoading();
    this.getPostDetails('post', media, );
  }
  onReplyClick(media: any) {
    if (this.isAnyLoading) return;
    this.loadingAction = "reply";
    this.feedLoadingService.setLoading();
    this.getPostDetails('reply', media, media.instagramObject.parent_id || media.instagramObject.id ,
      media.instagramObject.id , media.instagramObject.parent_id);
  }
  onViewReplyClick(media: any) {
    if (this.isAnyLoading) return;
    this.loadingAction = "view-reply";
    this.feedLoadingService.setLoading();
    this.getPostDetails('view-reply', media, media.instagramObject.parent_id || media.instagramObject.id ,
      media.instagramObject.id , media.instagramObject.parent_id);
  }
  getPostDetails( action: "reply" | 'view-reply' | 'post' | null , payload: any,
                 commentId?: string, replyId?: string, replyParentCommentId?: string) {
    if (this.isLoading) return;
    this.clickSubject.next(() => {
      this.isLoading = true;
      if (payload.item === "mentions") {
        this.openPostModal(action, payload);
        this.resetLoadingState();
        return;
      }

      this.instagramService.fetchPost(payload.instagramObject.media.id).subscribe({
        next: (response: any) => {
          this.openPostModal(action, response.data.payload, commentId, replyId, replyParentCommentId);
        },
        error: () => {
          this.toaster.error("Failed to fetch post", "Error");
          this.resetLoadingState();
        }
      });
    });
  }
  openPostModal(action: string, post: object, commentId?: string, replyId?: string, parentCommentId?: string) {
    this.instagramService.postToView.next({ action, post, commentId, replyId, parentCommentId });
  }
  timeAgo(timestamp: string): string {
    const now = new Date();
    const date = new Date(timestamp);
    const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (seconds < 60) {
      return 'Just now';
    }
    if (minutes === 1) {
      return '1 minute ago';
    }
    if (minutes < 60) {
      return `${minutes} minutes ago`;
    }
    if (hours === 1) {
      return '1 hour ago';
    }
    if (hours < 24) {
      return `${hours} hours ago`;
    }
    if (days === 1) {
      return 'Yesterday';
    }
    if (days === 2) {
      return '2 days ago';
    }
    if (days < 7) {
      return `${days} days ago`;
    }
    if (days < 8) {
      return `a week ago`;
    }

    // after 2 days return formatted date
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  }

}
